/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CancelOrderMutationVariables = {|
  orderId: string
|};
export type CancelOrderMutationResponse = {|
  +cancelOrder: ?{|
    +message: ?string
  |}
|};
export type CancelOrderMutation = {|
  variables: CancelOrderMutationVariables,
  response: CancelOrderMutationResponse,
|};
*/


/*
mutation CancelOrderMutation(
  $orderId: ID!
) {
  cancelOrder(orderId: $orderId) {
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orderId",
        "variableName": "orderId"
      }
    ],
    "concreteType": "CancelOrder",
    "kind": "LinkedField",
    "name": "cancelOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelOrderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelOrderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3beb7d1ae591839a76df1b6c11c5369b",
    "id": null,
    "metadata": {},
    "name": "CancelOrderMutation",
    "operationKind": "mutation",
    "text": "mutation CancelOrderMutation(\n  $orderId: ID!\n) {\n  cancelOrder(orderId: $orderId) {\n    message\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '76052dcc0ebca048be192231bdc57f27';

module.exports = node;
